import React from "react"; 
import OrderCargoProductsListPageContainer from "./OrderCargoProductsListPageContainer";
export class OrderCargoProductsListPage extends React.Component {
  render() {
    return <OrderCargoProductsListPageContainer {...this.props} />;
  }
}
